import i18n from "@/lib/i18n";

const SettingsContainer = () => import("./components/SettingsContainer.vue");
const TenantOrderingSettings = () => import("./views/TenantOrderingSettings.vue");
const TenantBillingSettings = () => import("./views/TenantBillingSettings.vue");
const TenantAccountingSettings = () => import("./views/TenantAccountingSettings.vue");
const TenantPaymentMethodsSettings = () => import("./views/TenantPaymentMethodsSettings.vue");
const TenantParentsSettings = () => import("./views/TenantParentsSettings.vue");
const TenantInstitutionWorkersSettings = () =>
  import("./views/TenantInstitutionWorkersSettings.vue");
const TenantHelpModuleSettings = () => import("./views/TenantHelpModuleSettings.vue");
const TenantEmailsSettings = () => import("./views/TenantEmailsSettings.vue");
const TenantSystemSettings = () => import("./views/TenantSystemSettings.vue");
const TenantCompanyDetailsSettings = () => import("./views/TenantCompanyDetailsSettings.vue");
const UsersSettings = () => import("./views/UsersSettings.vue");

const route = "/settings";

const routes = [
  {
    path: `${route}/tenant`,
    name: "settings.tenant",
    component: SettingsContainer,

    redirect: () => {
      return { name: "settings.tenant.ordering" };
    },

    props: {
      title: i18n.t("Tenant settings"),
      icon: "fa fa-building",
    },

    children: [
      {
        path: "ordering",
        name: "settings.tenant.ordering",
        component: TenantOrderingSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "billing",
        name: "settings.tenant.billing",
        component: TenantBillingSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "accounting",
        name: "settings.tenant.accounting",
        component: TenantAccountingSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "paymentMethods",
        name: "settings.tenant.paymentMethods",
        component: TenantPaymentMethodsSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "parents",
        name: "settings.tenant.parents",
        component: TenantParentsSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "institutionWorkers",
        name: "settings.tenant.institutionWorkers",
        component: TenantInstitutionWorkersSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "helpModule",
        name: "settings.tenant.helpModule",
        component: TenantHelpModuleSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "emails",
        name: "settings.tenant.emails",
        component: TenantEmailsSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "system",
        name: "settings.tenant.system",
        component: TenantSystemSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "companyDetails",
        name: "settings.tenant.companyDetails",
        component: TenantCompanyDetailsSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },

      {
        path: "users",
        name: "settings.tenant.users",
        component: UsersSettings,
        meta: { roles: ["ROLE_ADMIN"] },
      },
    ],
  },
];

export default routes;
